













































import { Component, Vue, Watch } from "vue-property-decorator";
import GenericBTable from "@/core/Generics/GenericBTable";
import Annoucement from "@/models/annoucement/annoucementPublish.Model";
import { BTableColumnType } from "@/enums/BTableColumnType";
import AnnoucementService from "@/services/Annoument.service";
import { PermissionValue } from "@/enums/PermissionValue";
import { RowTable } from "@/typings/BRowTable";
@Component
export default class AnnoucementPublishTableComponent extends GenericBTable<
  Annoucement
> {
  isLoading = false;
  annoucementService = new AnnoucementService();
  model: any;
  annoucementPublished: Array<any>;
  constructor() {
    super();
    this.annoucementPublished = [];
    this.model = new Annoucement();
  }
  created() {
    this.getAllPublished();
  }
  public getAllPublished() {
    this.annoucementService.getPublish().then(response => {
      this.annoucementPublished = response;
    });
  }
  view(id: number, data: Annoucement, props: RowTable<Annoucement>) {
    this.$router.push(`convocatoria/detail/${id}`);
  }
}
